var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 42,
    viewBox: "0 0 61 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1526 40.9863H60.8456",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5066 27.3963L22.4444 15.6963L4.70561 12.7263L4.94438 11.2463L23.0214 14.2763L39.5066 25.5763L57.126 13.3663L57.9816 14.6063L39.5066 27.3963Z",
    fill: "#0298A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33279 13.9863C4.70644 13.9863 5.82 12.867 5.82 11.4863C5.82 10.1056 4.70644 8.98633 3.33279 8.98633C1.95914 8.98633 0.845581 10.1056 0.845581 11.4863C0.845581 12.867 1.95914 13.9863 3.33279 13.9863Z",
    fill: "#0298A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2304 17.9863C24.6041 17.9863 25.7177 16.867 25.7177 15.4863C25.7177 14.1056 24.6041 12.9863 23.2304 12.9863C21.8568 12.9863 20.7432 14.1056 20.7432 15.4863C20.7432 16.867 21.8568 17.9863 23.2304 17.9863Z",
    fill: "#0298A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1486 28.9863C40.5222 28.9863 41.6358 27.867 41.6358 26.4863C41.6358 25.1056 40.5222 23.9863 39.1486 23.9863C37.7749 23.9863 36.6614 25.1056 36.6614 26.4863C36.6614 27.867 37.7749 28.9863 39.1486 28.9863Z",
    fill: "#0298A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0514 15.9863C59.425 15.9863 60.5386 14.867 60.5386 13.4863C60.5386 12.1056 59.425 10.9863 58.0514 10.9863C56.6777 10.9863 55.5641 12.1056 55.5641 13.4863C55.5641 14.867 56.6777 15.9863 58.0514 15.9863Z",
    fill: "#0298A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.397 31.4763L3.26283 30.4963L22.4939 8.11632L40.5411 14.1563L57.1457 3.35632L57.9615 4.61632L40.7401 15.8163L22.9715 9.85632L4.397 31.4763Z",
    fill: "#003F7F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33279 33.9863C4.70644 33.9863 5.82 32.867 5.82 31.4863C5.82 30.1056 4.70644 28.9863 3.33279 28.9863C1.95914 28.9863 0.845581 30.1056 0.845581 31.4863C0.845581 32.867 1.95914 33.9863 3.33279 33.9863Z",
    fill: "#003F7F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2304 10.9863C24.6041 10.9863 25.7177 9.86704 25.7177 8.48633C25.7177 7.10562 24.6041 5.98633 23.2304 5.98633C21.8568 5.98633 20.7432 7.10562 20.7432 8.48633C20.7432 9.86704 21.8568 10.9863 23.2304 10.9863Z",
    fill: "#003F7F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1435 16.9863C41.5171 16.9863 42.6307 15.867 42.6307 14.4863C42.6307 13.1056 41.5171 11.9863 40.1435 11.9863C38.7698 11.9863 37.6562 13.1056 37.6562 14.4863C37.6562 15.867 38.7698 16.9863 40.1435 16.9863Z",
    fill: "#003F7F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0514 5.98633C59.425 5.98633 60.5386 4.86704 60.5386 3.48633C60.5386 2.10562 59.425 0.986328 58.0514 0.986328C56.6777 0.986328 55.5641 2.10562 55.5641 3.48633C55.5641 4.86704 56.6777 5.98633 58.0514 5.98633Z",
    fill: "#003F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.b37f658463cfac0cc15893c2759857b7.svg";
export { ForwardRef as ReactComponent };